import type { ShouldUpdateScrollArgs } from "gatsby";

export const shouldUpdateScroll = ({ routerProps: { location } }:ShouldUpdateScrollArgs) => {
  // If there's a hash, let the browser handle the anchor
  if (location.hash) return false;

  // Always scroll to top on route change
  return [0, 0]; // Gatsby will set scroll to (0,0)
};